(() => {
  let refreshing = false;
  const clearTransientUI = () => {
    document.querySelectorAll('.ug-cart-flight').forEach(node => node.remove());
    document.querySelectorAll('details-modal').forEach(modal => {
      if (modal.isOpen?.()) modal.close(false);
    });
  };
  window.addEventListener('pagehide', clearTransientUI);
  window.addEventListener('pageshow', async event => {
    if (!event.persisted || refreshing) return;
    clearTransientUI();
    refreshing = true;
    try {
      const cart = document.querySelector('cart-items');
      if (cart?.onCartUpdate) {
        window.UGCartRuntime?.begin();
        await cart.onCartUpdate();
      } else {
        const route = window.routes?.cart_url || '/cart';
        const response = await fetch(`${route}?sections=cart-icon-bubble`, { credentials: 'same-origin' });
        if (!response.ok) return;
        const data = await response.json();
        const html = data['cart-icon-bubble'];
        if (!html) return;
        const source = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        const icon = document.getElementById('cart-icon-bubble');
        if (icon && source) icon.replaceChildren(...source.childNodes);
      }
    } catch (error) {
      // Keep the restored page usable if refreshing the cart fails.
    } finally {
      try {
        if (window.UGCartRuntime?.busy) await window.UGCartRuntime.end();
      } finally {
        refreshing = false;
      }
    }
  });
})();
